import history, { applyHistoryMiddlewares } from './history';

export { applyHistoryMiddlewares };

export default history;
